import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import clickOutside from 'react-click-outside';
import classnames from 'classnames';

import FinishedTypingTextBox from '../../../../../../../../components/Form/FinishedTyping';
import Spinner from '../../../../../../../../components/Spinner/';

import './MajorSelector.scss';

class MajorSelector extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      visible: false,
      firstTimeLoad: true,
      selectedEntry: null,
      SearchFinished: false,
      value: props.defaultValue || {
        id: null,
        name: ''
      },
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChange = this.handleChange.bind(this); // When finished typing
    this.handleTyping = this.handleTyping.bind(this); // Every Key press
    this.handleClick = this.handleClick.bind(this);
    this.handleOnKey = this.handleOnKey.bind(this);
    this.respondOnChange = this.respondOnChange.bind(this); // Propogates Valuechange upstream
  }

  handleClickOutside(event) {
    this.setState({
      visible: false
    });
  }

  handleFocus(event) {
    this.setState({
      visible: true
    });
  }

  handleChange(event) { // When finished typing
    this.setState({
      firstTimeLoad: false,
      SearchFinished: false,
      value: {
        id: null,
        name: event.target.value
      },
    });

    if (event.target.value.length > 0) {
      this.props.SearchMajors.refetch({
        searchParam: event.target.value
      }).then(() => {
        this.setState({
          SearchFinished: true,
        });
      });
    }
  }

  handleTyping(event) { // Every key press
    this.setState({
      SearchFinished: false,
      value: {
        id: null,
        name: event.target.value
      },
    });
    this.respondOnChange({
      id: null,
      name: event.target.value
    });
  }

  handleClick = newValue => (event) => {
    this.setState({
      visible: false,
      value: newValue,
      selectedEntry: null,
    });
    this.respondOnChange(newValue);
  }

  respondOnChange(val) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          value: val
        }
      });
    }
  }

  handleOnKey(event) {
    switch (event.keyCode) {
      case 38: // Up
        event.preventDefault();
        if (this.state.selectedEntry !== null && this.state.selectedEntry !== 0) {
          this.setState({
            selectedEntry: (this.state.selectedEntry - 1),
          });
        }
        break;
      case 40: // Down
        event.preventDefault();
        if (this.state.selectedEntry === null || this.state.selectedEntry !== (this.props.maxDisplayLength - 1)) {
          if (this.state.selectedEntry !== null) {
            this.setState({
              selectedEntry: (this.state.selectedEntry + 1),
            });
          } else {
            this.setState({
              selectedEntry: 0,
            });
          }
        }
        break;
      case 13: // Enter
        event.preventDefault();
        this.textInput.blur();
        if (this.state.selectedEntry !== null) {
          this.handleClick(this.props.SearchMajors.searchMajors[this.state.selectedEntry])();
        } else {
          this.handleClickOutside();
        }
        break;
      case 9: // Tab
        this.handleClickOutside();
        break;
    }
  }

  render() {
    const propsToOmit = ['onChange', 'handleOnKey', 'name', 'maxDisplayLength', 'SearchMajors', 'defaultValue'];
    let spreadProps = {};

    Object.keys(this.props).forEach((value) => {
      if (propsToOmit.indexOf(value) === -1) {
        spreadProps[value] = this.props[value];
      }
    });

    return (
      <div className='MajorSelector'>
        <FinishedTypingTextBox value={this.state.value.name} delay={300} name={this.props.name} onChange={this.handleChange}
          onFocus={this.handleFocus} currentValue={this.handleTyping} onKeyDown={this.handleOnKey}
          inputRef={(input) => { this.textInput = input }} {...spreadProps} />
        {(this.props.SearchMajors.loading && this.state.firstTimeLoad === false) ? <Spinner /> : null}
        <ul className='MajorSelector__SuggestionsWrap' style={(this.state.visible && this.state.SearchFinished) ? {} : { display: 'none' }}>
          {(this.props.SearchMajors.searchMajors || []).slice(0, this.props.maxDisplayLength).map((major, index) => (
            <li onClick={this.handleClick(major)} className={classnames({
              'MajorSelector__Suggestion': true,
              'MajorSelector__Suggestion--selected': this.state.selectedEntry === index
            })} key={major.id}>
              {major.name}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

MajorSelector.propTypes = {
  name: React.PropTypes.string.isRequired,
  maxDisplayLength: React.PropTypes.number,
  onChange: React.PropTypes.func
};

MajorSelector.defaultProps = {
  maxDisplayLength: 4,
};

const SearchMajorQuery = gql`
  query SearchMajors($searchParam: String) {
    searchMajors(like: $searchParam) {
      id
      name
    }
  }
`;

export default graphql(SearchMajorQuery, {
  name: 'SearchMajors'
})(clickOutside(MajorSelector));



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Education/components/MajorSelector/index.js